export default function TermsPage() {
  return (
    <div style={{ minHeight: '100vh', background: '#050510', padding: '80px 24px', color: '#f0f0ff' }}>
      <div style={{ maxWidth: 680, margin: '0 auto' }}>
        <h1 style={{ fontSize: 28, fontWeight: 800, marginBottom: 24 }}>Terms of Service</h1>
        <p style={{ color: '#8888aa', fontSize: 14, lineHeight: 1.8, marginBottom: 16 }}>
          Last updated: March 2026
        </p>
        <div style={{ color: '#8888aa', fontSize: 14, lineHeight: 1.8 }}>
          <h2 style={{ color: '#f0f0ff', fontSize: 18, fontWeight: 700, marginTop: 28, marginBottom: 12 }}>1. Acceptance of Terms</h2>
          <p>By accessing and using StartupScore ("the Service"), you accept and agree to be bound by these Terms of Service. If you do not agree, do not use the Service.</p>

          <h2 style={{ color: '#f0f0ff', fontSize: 18, fontWeight: 700, marginTop: 28, marginBottom: 12 }}>2. Description of Service</h2>
          <p>StartupScore provides AI-powered startup idea validation tools, including market analysis, positioning guidance, and MVP planning. The Service uses artificial intelligence and should not be considered financial, legal, or professional business advice.</p>

          <h2 style={{ color: '#f0f0ff', fontSize: 18, fontWeight: 700, marginTop: 28, marginBottom: 12 }}>3. User Accounts</h2>
          <p>You are responsible for maintaining the confidentiality of your account credentials. You agree to provide accurate information and to update it as necessary.</p>

          <h2 style={{ color: '#f0f0ff', fontSize: 18, fontWeight: 700, marginTop: 28, marginBottom: 12 }}>4. Credits and Payments</h2>
          <p>Certain features require credits, which can be purchased through the Service. Credits are non-refundable and non-transferable. Prices are subject to change with notice.</p>

          <h2 style={{ color: '#f0f0ff', fontSize: 18, fontWeight: 700, marginTop: 28, marginBottom: 12 }}>5. Intellectual Property</h2>
          <p>Your ideas and data remain yours. AI-generated outputs are provided for your use. You grant us a limited license to process your data to provide the Service.</p>

          <h2 style={{ color: '#f0f0ff', fontSize: 18, fontWeight: 700, marginTop: 28, marginBottom: 12 }}>6. Limitation of Liability</h2>
          <p>The Service is provided "as is" without warranties. We are not liable for business decisions made based on AI-generated analysis.</p>

          <h2 style={{ color: '#f0f0ff', fontSize: 18, fontWeight: 700, marginTop: 28, marginBottom: 12 }}>7. Contact</h2>
          <p>For questions about these terms, contact us at support@startupscore.live.</p>
        </div>
      </div>
    </div>
  );
}
